// Convert a major-unit amount (naira, dollars) to the integer minor units
// (kobo, cents) payment providers expect. Rounds rather than floors:
// 19.99 * 100 is 1998.9999999999998 in floating point.
export const toMinorUnits = (amount) => Math.round(Number(amount) * 100);
